// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){ 

	$(document).ready(function () {
		// if(window.location.hash) {
		// 	setTimeout(function(){ 
		// 		$('html, body').animate({scrollTop: $(window.location.hash).offset().top - 60}, 500);
		// 	    return false;
		//     }, 500);
		// }
		$(".birthday").datepicker({
		    yearRange: '1940:2010',
		    changeYear: true
		});
	});

	window.onload = function() {

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(document.getElementById('home')) {
		//document.querySelector(".top-content__circle").style.bottom = '-' + (st-50) + 'px';
		$('.top-content__circle').css('bottom','-' + (st-50) + 'px');
	}
	if(st > 80){ 
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}
}